<template>
     <div class="container">
      <div class="tit">
        <h3>行业热词</h3>
        <div class="titCenter">
          <span class="titCenterAct">品类词</span>
          <span>品牌词</span>
          <span>功效词</span>
        </div>
        <h1 class="el-icon-arrow-down"></h1>
      </div>
      <div class="search">
        <el-autocomplete
          class="inline-input"
          v-model="state2"
          :fetch-suggestions="querySearch"
          placeholder="搜索关键词"
          :trigger-on-focus="false"
          @select="handleSelect"
        ></el-autocomplete>
        <div class="changeType">
          <span class="typeAct">转化<i class="el-icon-bottom"></i></span>
          <span>流量<i class="el-icon-bottom"></i></span>
          <span>客单价<i class="el-icon-bottom"></i></span>
        </div>
      </div>
      <div class="loopCon">
        <van-swipe @change="onChange" indicator-color="#B6B6DF">
          <van-swipe-item v-for="item in 5" :key="item">
            <div class="box">
              <div class="mainTie">
                <div class="mainTieTop">
                  <span class="mainTieTopAct">SOD蜜</span>

                  <span>查看</span>
                </div>
                <div class="mainTieBot">
                  <div class="botLef Bot">
                    <p>流量</p>
                    <b>1000</b>
                    <span class="info">29</span>
                  </div>
                  <div class="botCen Bot">
                    <p>转化</p>
                    <b>100%</b>
                  </div>
                  <div class="botRih Bot">
                    <p>客单价</p>
                    <b>100%</b>
                  </div>
                </div>
              </div>
              <div class="table" style="display: none">
                <div class="tableHead">
                  <van-row gutter="5">
                    <van-col span="4"><span class="opa">1</span></van-col>
                    <van-col span="5">流量</van-col>
                    <van-col span="5">转化</van-col>
                    <van-col span="5">客单</van-col>
                    <van-col span="5">支付金额</van-col>
                  </van-row>
                </div>
                <div class="tableMain">
                  <van-row gutter="5">
                    <van-col span="4">1</van-col>
                    <van-col span="5">1</van-col>
                    <van-col span="5">1</van-col>
                    <van-col span="5">1</van-col>
                    <van-col span="5">1</van-col>
                  </van-row>
                </div>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
        <p class="infoImg el-icon-right">向右滑动查看更多</p>
      </div>
      <div class="tit" style="margin-top: 60px">
        <h3>关注词</h3>
        <div class="titCenter opa"></div>
        <h1 class="el-icon-arrow-down"></h1>
      </div>
      <div class="search">
        <div class="opa">1</div>
        <div class="changeType" style="width: 28%">
          <span class="typeAct">流量<i class="el-icon-bottom"></i></span>
          <span>增长速度<i class="el-icon-bottom"></i></span>
        </div>
      </div>
      <div class="loopCon">
        <van-swipe @change="onChange" indicator-color="#B6B6DF">
          <van-swipe-item v-for="item in 5" :key="item">
            <div class="box">
              <div class="mainTie">
                <div class="mainTieTop">
                  <span class="mainTieTopAct">SOD蜜</span>

                  <span>查看</span>
                </div>
                <div class="mainTieBot">
                  <div class="botLef Bot">
                    <p>流量</p>
                    <b>1000</b>
                    <span class="info">29</span>
                  </div>
                  <div class="botCen Bot">
                    <p>转化</p>
                    <b>100%</b>
                  </div>
                  <div class="botRih Bot">
                    <p>客单价</p>
                    <b>100%</b>
                  </div>
                </div>
              </div>
              <div class="table" style="display: none">
                <div class="tableHead">
                  <van-row gutter="5">
                    <van-col span="4"><span class="opa">1</span></van-col>
                    <van-col span="5">流量</van-col>
                    <van-col span="5">转化</van-col>
                    <van-col span="5">客单</van-col>
                    <van-col span="5">支付金额</van-col>
                  </van-row>
                </div>
                <div class="tableMain">
                  <van-row gutter="5">
                    <van-col span="4">1</van-col>
                    <van-col span="5">1</van-col>
                    <van-col span="5">1</van-col>
                    <van-col span="5">1</van-col>
                    <van-col span="5">1</van-col>
                  </van-row>
                </div>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
        <p class="infoImg el-icon-right">向右滑动查看更多</p>
      </div>
    </div>
</template>
<script>
export default {
    data(){
        return{}
    },
    methods:{
    onChange(index) {},

    }
}
</script>
<style scoped>
.container {
  box-sizing: border-box;
  padding: 20px 20px 40px;
  position: relative;
  top: -20px;
  border-radius: 10px;
  background-color: rgb(245, 247, 250);
  width: 100%;
}
.tit {
  padding: 10px 0px;
  width: 100%;
  height: 40px;
  line-height: 40px;
  background: rgb(94, 105, 140);
  border-radius: 15px;
  margin: 10px auto;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.tit h3,
h1 {
  color: #fff;
  font-weight: bold;
}
.titCenter {
  height: 30px;
  width: 50%;
  background-color: rgb(52, 63, 95);
  border-radius: 10px;
  line-height: 30px;
  display: flex;
  align-items: center;
}
.titCenter span {
  text-align: center;
  color: lightgray;
  flex: 1;
}
.titCenterAct {
  color: rgb(52, 63, 95) !important;
  background-color: #fff;
  border-radius: 10px;
  width: 30%;
}
.search {
  width: 100%;
  height: 30px;
  padding: 10px auto;
  display: flex;
  line-height: 30px;
  align-items: center;
  justify-content: space-between;
}
/deep/ .el-input .el-input__inner {
  border-radius: 15px;
  box-shadow: 0 5px 20px -10px lightgray;

  height: 30px;
}
.changeType {
  width: 38%;
  display: flex;
  justify-content: space-between;
}
.changeType span {
  color: #ccc;
}
.typeAct {
  color: #000 !important;
  font-weight: bold;
  border-bottom: 2px solid #000;
}
.infoImg {
  font-family: "SourceHanSansCN-Medium";
  font-size: 13px;
  font-weight: bold;
  color: #9d9dd4;
  letter-spacing: 0;
  text-align: center;
  position: absolute;
  bottom: 0;
  right: 10px;
}
.opa {
  opacity: 0;
}
.mainTie {
  box-shadow: 0 5px 20px -10px lightgray;
  overflow: hidden;
  margin: 10px auto;
  height: 80px;
  background: rgb(255, 255, 255);
  border-radius: 20px;
  position: relative;
}
.secTie {
  text-align: center;
  padding: 0 10px;
  margin: 10px auto;
  background: #e8e8f6;
  color: #343434;
}
.tableHead {
  position: relative;
  padding-bottom: 10px;
  text-align: center;
  line-height: 20px;
}
.tableHeadInfo1 {
  top: -40px;
  left: 3%;
  position: absolute;
  color: #343434;
}
.tableHeadInfo {
  top: -20px;
  left: 3%;
  position: absolute;
  color: #343434;
}
.tableMain {
  font-family: "ArialMT";
  color: #002f00;
  margin: 10px 0;
  text-align: center;
  line-height: 20px;
}
.loopCon {
  margin-bottom: 15px;
  position: relative;
}
.echartsBox {
  position: relative;
}
.echartsButton {
  z-index: 9;
  position: absolute;
  width: 100px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  left: 15%;
  top: 5%;
}
.echarts {
  min-width: 100% !important;
  height: 260px;
}
/deep/ .van-swipe {
  padding-bottom: 20px;
}
/deep/ .van-swipe__indicators {
  bottom: 0px;
  left: 30%;
}
/deep/ .van-swipe__indicator {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  background-color: rgb(227, 227, 244);
}
/deep/ .van-swipe__indicators::before {
  font-weight: bold;
  content: "<";
  margin-right: 10px;
  font-family: "PingFangSC-Regular";
  color: #8b8d96;
  font-size: 16px;
  line-height: 11px;
}
/deep/ .van-swipe__indicators::after {
  font-weight: bold;
  content: ">";
  margin-left: 10px;
  font-family: "PingFangSC-Regular";
  color: #8b8d96;
  font-size: 16px;
  line-height: 11px;
}
/deep/ .van-swipe__indicator--actives {
  width: 30px;
}
.info {
  color: #daa520;
}
.mainTieTop {
  padding: 8px 0;
  width: 100%;
  display: flex;
  height: 40%;
  align-items: center;
  justify-content: space-between;
  text-align: center;
}
.mainTieTop span {
  padding: 5px 10px;
}
.mainTieTopAct {
  background: rgb(237, 85, 85);
  border-radius: 0 10px 10px 0;
  color: #fff;
}
.mainTieBot {
  width: 100%;
  height: 55%;
  display: flex;
  justify-content: space-around;
}
.Bot {
  display: flex;
  width: 35%;
  display: flex;
  justify-content: center;
  line-height: 100%;
  padding: 0 10px 10px;
}
.Bot p {
  color: lightgray;
}
.Bot b {
  font-size: 20px;
  margin: 0 10px;
}
.Bot span {
}
</style>


// WEBPACK FOOTER //
// src/components/ButSix_vs/VsBen/BenSerach.vue